import Block from '../block'
import debounce from 'lodash.debounce'
import gsap from 'gsap'

const MINIMAL_QUERY_LENGTH = 3

// timings match the nav dropdown
const DURATION = {
	open: 0.35,
	close: 0.25,
	in: 0.3,
	out: 0.2,
	stagger: 0.25,
}

// clip-path instead of height, the layer has a min-height and top padding
const CLIP_CLOSED = 'inset(0% 0% 100% 0%)'
const CLIP_OPEN = 'inset(0% 0% 0% 0%)'

export default class Search extends Block {
	static title = 'search'

	constructor($el) {
		super($el)

		this.results = this.$el.findElement('results')
		this.fades = this.$el.findElement('input-container').add(this.results)
		this.isOpen = false
		this.timeline = null

		// this block requires this data attribute to initialize
		// otherwise it will fall back to the default search
		if (this.$el.data('autocomplete')) {
			this.$el.findElement('input').keyup(
				debounce((event) => this.handleSearchInput(event), 1500, {
					leading: true,
				}),
			)
		}

		$(document).on('search:toggle', (e, data) =>
			data.open ? this.open() : this.close(),
		)
	}

	// both directions tween from the current state, so a reversed toggle does not jump
	open() {
		if (this.isOpen) return

		this.isOpen = true
		this.timeline?.kill()

		if (this.$el.hasClass('hidden')) {
			gsap.set(this.$el, { clipPath: CLIP_CLOSED })
			gsap.set(this.fades, { autoAlpha: 0, y: 8 })
			this.$el.removeClass('hidden')
		}

		this.timeline = gsap
			.timeline()
			.to(
				this.$el,
				{ clipPath: CLIP_OPEN, duration: DURATION.open, ease: 'power3.out' },
				0,
			)
			.to(
				this.fades,
				{
					autoAlpha: 1,
					y: 0,
					duration: DURATION.in,
					stagger: { amount: DURATION.stagger },
					ease: 'power3.out',
				},
				0.1,
			)
	}

	close() {
		if (!this.isOpen) return

		this.isOpen = false
		this.timeline?.kill()

		this.timeline = gsap
			.timeline({
				onComplete: () => {
					this.$el.addClass('hidden')
					gsap.set(this.$el.add(this.fades), { clearProps: 'all' })
				},
			})
			.to(
				this.fades,
				{
					autoAlpha: 0,
					y: -4,
					duration: DURATION.out * 0.7,
					ease: 'power2.in',
				},
				0,
			)
			.to(
				this.$el,
				{ clipPath: CLIP_CLOSED, duration: DURATION.close, ease: 'power2.in' },
				0.05,
			)
	}

	handleSearchInput(event) {
		this.loading(true)
		// enter press = search
		if (event.keyCode === 13) {
			return
		}

		const query = event.target.value

		if (query.length === 0 || event.keyCode === 27) {
			return
		}

		if (query.length < MINIMAL_QUERY_LENGTH) {
			return
		}

		this.autocompleteRequest?.abort()
		this.autocompleteRequest = $.getJSON(
			`/search?autocomplete&term=${encodeURIComponent(query)}`,
		)
			.done((json) => {
				this.results.html(json.html)
			})
			.fail((error) => {
				if (error.statusText !== 'abort') {
					$(document).trigger('message:error', { message: error })
					this.loading(false)
				}
			})
	}

	loading(status) {
		if (status) {
			this.results.html(
				"<div class='search__loading'><sl-spinner></sl-spinner></div>",
			)
		} else {
			this.results.html('')
		}
	}
}
